import styled from 'styled-components';
import { Modal } from 'antd';

export const TrailerModalContainer = styled(Modal)`
  .ant-modal-body {
    padding: 0;

    .course-trailer-container {
      width: 100%;
      position: relative;
      overflow: hidden;
      padding-top: 56.25%;

      iframe {
        border-radius: 0 0 6px 6px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }
    }

    .warning {
      padding: 20px;

      p {
        text-align: justify;
        margin-bottom: 0;
      }
    }
  }
`;
